<nav class="navbar" aria-label="Primary navigation">
	@for (item of items; track item.link) {
		<a
			class="navbar__tab"
			[class.navbar__tab--soon]="item.comingSoon"
			[routerLink]="item.link"
			routerLinkActive="navbar__tab--active"
			[routerLinkActiveOptions]="{ exact: item.exact ?? false }">
			<svg class="navbar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
				@switch (item.icon) {
					@case ('inbox') { <path d="M4 5h16M4 12h16M4 19h10" /> }
					@case ('network') { <circle cx="6" cy="6" r="2.5" /><circle cx="18" cy="18" r="2.5" /><circle cx="18" cy="6" r="2.5" /><path d="M8 6h6M8 6l8 10" /> }
					@case ('agentRuns') { <rect x="5" y="8" width="14" height="10" rx="2" /><circle cx="9.5" cy="13" r="1" /><circle cx="14.5" cy="13" r="1" /><path d="M12 4v4M8 18v2M16 18v2" /> }
				}
			</svg>
			<span class="navbar__label">{{ item.label }}</span>
			@if (item.comingSoon) {
				<span class="navbar__badge">Soon</span>
			}
		</a>
	}
</nav>
